import getVisibleColumns from './getVisibleColumns';

const getInitialVisibleColumns = (visibleColumns, columns) =>
  visibleColumns ? getVisibleColumns(visibleColumns, columns) : null;

export default getInitialVisibleColumns;
